// src/components/issues/PastilleModifie.tsx — SCE Issues
// Pastille « Modifié » d'un champ de la fiche (02/10, maquette F de
// https://claude.ai/artifact/5RPwymPvNPU5LBgQrwi1sd, version retenue par Guillaume) :
// un rond jaune sans contour, qui s'étend au survol en « Modifié il y a 2 h »,
// avec un libellé « Avant : … » sous lui.
//
// Posée par la fiche sur les champs que l'événement cliqué dans l'activité
// récente a touchés (utils/champsModifies). Rien n'est enregistré : elle
// disparaît avec la fiche.
//
// Au clavier ou au toucher, le focus fait ce que fait le survol : c'est un
// bouton, pas un simple décor.

import { libelleAge } from '@/utils/accueil'

/** Au-delà, l'ancienne valeur est coupée : une description citée peut être longue. */
const AVANT_MAX = 140

export function PastilleModifie({
  date,
  avant,
  maintenant,
  versLaGauche,
}: {
  /** Date de l'événement, ISO. */
  date: string
  /** Ancienne valeur ; absente : pas de libellé (événement sans valeur à citer). */
  avant: string | undefined
  maintenant: number
  /** S'étend vers la gauche — pastille posée au bord droit d'une carte. */
  versLaGauche?: boolean
}): JSX.Element {
  const age = libelleAge(date, maintenant)
  const quand = !age ? 'Modifié' : age === 'à l\'instant' ? 'Modifié à l\'instant' : `Modifié il y a ${age}`
  const valeur = avant === undefined ? null : avant === '' ? '(vide)' : coupe(avant)
  return (
    <button
      type="button"
      className={versLaGauche ? 'pastille-modif pastille-modif--gauche' : 'pastille-modif'}
      aria-label={valeur === null ? quand : `${quand}. Avant : ${valeur}`}
    >
      <span className="pastille-modif-corps" aria-hidden="true">
        <span className="pastille-modif-texte">{quand}</span>
      </span>
      {valeur !== null && (
        <span className="pastille-modif-avant" aria-hidden="true">
          Avant : <strong style={{ fontWeight: 600 }}>{valeur}</strong>
        </span>
      )}
    </button>
  )
}

function coupe(texte: string): string {
  const propre = texte.replace(/\s+/g, ' ').trim()
  return propre.length > AVANT_MAX ? `${propre.slice(0, AVANT_MAX).trimEnd()}…` : propre
}
